// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RouterSuspendingProcessModal_wrap__3pSYe","title":"RouterSuspendingProcessModal_title__2DyYc","detailText":"RouterSuspendingProcessModal_detailText__e20mh"};